uniform vec2 resolution;
uniform float time;
varying vec2 vUv;

// Returns a cell in vec3 formation:
//  xy: -1.0:1.0 position in cell
//  zw: x and y index of cell
vec4 makeCell(vec2 st, float width) {
    st = st + vec2(width / 2.); // This centers the grid
    vec2 p = (mod(st, width) / width) * 2.0 - 1.0;
    return vec4(p, floor(st / width));
}
float sdPentagon(in vec2 p, in float r) {
    const vec3 k = vec3(0.809016994, 0.587785252, 0.726542528);
    p.x = abs(p.x);
    p -= 2.0 * min(dot(vec2(-k.x, k.y), p), 0.0) * vec2(-k.x, k.y);
    p -= 2.0 * min(dot(vec2(k.x, k.y), p), 0.0) * vec2(k.x, k.y);
    p -= vec2(clamp(p.x, -r * k.z, r * k.z), r);
    return length(p) * sign(p.y);
}

float dot2( in vec2 v ) { return dot(v,v); }

float sdHeart( in vec2 p )
{
    p.x = abs(p.x);

    if( p.y+p.x>1.0 )
        return sqrt(dot2(p-vec2(0.25,0.75))) - sqrt(2.0)/4.0;
    return sqrt(min(dot2(p-vec2(0.00,1.00)),
                    dot2(p-0.5*max(p.x+p.y,0.0)))) * sign(p.x-p.y);
}

float sdStar5(in vec2 p, in float r, in float rf)
{
    const vec2 k1 = vec2(0.809016994375, -0.587785252292);
    const vec2 k2 = vec2(-k1.x,k1.y);
    p.x = abs(p.x);
    p -= 2.0*max(dot(k1,p),0.0)*k1;
    p -= 2.0*max(dot(k2,p),0.0)*k2;
    p.x = abs(p.x);
    p.y -= r;
    vec2 ba = rf*vec2(-k1.y,k1.x) - vec2(0,1);
    float h = clamp( dot(p,ba)/dot(ba,ba), 0.0, r );
    return length(p-ba*h) * sign(p.y*ba.x-p.x*ba.y);
}

float sdEquilateralTriangle( in vec2 p, in float r )
{
    const float k = sqrt(3.0);
    p.x = abs(p.x) - r;
    p.y = p.y + r/k;
    if( p.x+k*p.y>0.0 ) p = vec2(p.x-k*p.y,-k*p.x-p.y)/2.0;
    p.x -= clamp( p.x, -2.0*r, 0.0 );
    return -length(p)*sign(p.y);
}

float areEqual(float a, float b) {
    return 1.0 - step(0.0001, abs(a-b));
}  

void main() {

    vec2 uv = vUv;
    uv -= 0.5;
    vec2 st = uv * resolution;
    vec4 cell = makeCell(st, 120.);

    vec2 p = cell.xy;
    vec2 index = cell.zw;

    float v = 0.0;

    float pentagon = 1.0 - sdPentagon(p * vec2(1.,-1.), 0.5);
    float heart = 1.0 - sdHeart(p + vec2(0.0, 0.55));
    float star5 = 1.0 - sdStar5(p, 0.8, 0.4);
    float triangle = 1.0 - sdEquilateralTriangle(p + vec2(0., .15), 0.7);

    index.x += (index.y * 2.0) + floor(time * 0.001); 
    index = mod(index, vec2(4));

    v += pentagon * areEqual(index.x, 0.);
    v += heart * areEqual(index.x, 1.);
    v += star5 * areEqual(index.x, 2.);
    v += triangle * areEqual(index.x, 3.);

    //v = triangle;

    // Debug grid
    vec2 isEdge = smoothstep(vec2(0.8), vec2(1.0), abs(p));
    float onEdge = max(isEdge.x, isEdge.y);
    v = max(v, onEdge);

    vec3 aColor = vec3(0.0);
    vec3 bColor = vec3(0.0, 0.95, 1.0);

    vec3 outColor = mix(aColor, bColor, smoothstep(0.95, 1.0, v));

    gl_FragColor = vec4(outColor, 1.0);

    // gl_FragColor = vec4(cell.x * (abs(cell.z) * 0.2), cell.y  * (abs(cell.w) * 0.2), (abs(cell.z) * 0.2) +  (abs(cell.w) * 0.2), 1.0);
}